module.exports = __webpack_public_path__ + "static/SoleilSemiBold-47c19c0a0b15340c7a4fca0d8c789905.otf";